import { BUSCAR_ITINERARIO, SELECIONAR_ITINERARIO } from '../../actions/types'

const initialState = null
const itinerarioInicial = {
  rotaDto: {
    cidadeOrigem: {},
    cidadeDestino: {},
    trechosDto: []
  },
  veiculoDto:{

  }
}

export default function reducerItinerarioSelecionado (state = itinerarioInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_ITINERARIO: {
      if (action.payload == null) {
        return itinerarioInicial;
      }
      return action.payload;
    }

    case BUSCAR_ITINERARIO: {
      return action.payload.data;
    }


    default: {
      return state
    }
  }
}
